import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { styled } from 'styled-components';
import { useExpandedFdocContentContext } from '../../../ExpandedFdoc/ExpandedFdocContentContext.js';
import { ButtonIconDownload } from '@fabric-app/ui/components/button/ButtonIconDownload';
import { Flex } from '@fabric-app/ui/components/Flex';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { isDefined } from '@fabric-app/utils/guards';
import { Transcript } from '../../../../../mediaPlaying/components/Transcript.js';

const PaddedModal = styled(Modal.Body).withConfig({
  displayName: "ResourceMediaPlayer__PaddedModal",
  componentId: "sc-b506238d-0"
})([
  `min-height:100%;`,
  `{padding-bottom:4.5rem;}`
], mediaMobile);
const ResourceMediaPlayer = ({ children, handleDownload, transcriptLines, currentTimestamp, onTranscriptClick, containerRef }) => {
  const { topHeaderControlsRef } = useExpandedFdocContentContext();
  const downloadButton = !!handleDownload && topHeaderControlsRef ? /* @__PURE__ */ createPortal(/* @__PURE__ */ jsx(ButtonIconDownload, {
    onClick: handleDownload
  }), topHeaderControlsRef) : null;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      downloadButton,
      /* @__PURE__ */ jsx(ScrollArea.Default, {
        grow: true,
        expandVertically: true,
        ref: containerRef,
        "data-pan-id-ignore-resource-drag-resize": "xy",
        children: /* @__PURE__ */ jsx(PaddedModal, {
          background: "tertiary",
          children: /* @__PURE__ */ jsxs(Flex, {
            direction: "column",
            gap: "elementsContainer",
            alignItems: "center",
            justifyContent: !isDefined(transcriptLines) ? "center" : "flex-start",
            minHeight: 0,
            flexGrow: true,
            children: [
              children,
              isDefined(transcriptLines) && /* @__PURE__ */ jsx(Transcript, {
                transcriptLines,
                onTranscriptLineClick: onTranscriptClick,
                currentTimestamp
              })
            ]
          })
        })
      })
    ]
  });
};

export { ResourceMediaPlayer };
//# sourceMappingURL=ResourceMediaPlayer.js.map
